import React from 'react';

import Container from 'components/Container';

const Footer = () => {
  return (
    <footer>
      <Container>
        <p>
          <a href="https://hthshacks-20.devpost.com/">For HTHS Hacks 2020</a>
        </p>
      </Container>
    </footer>
  );
};

export default Footer;
